<template>
  <a-icon-sheet-card
    title="Recruiting.Dashboard.OpenTasksTitle"
    :count="data.count"
  >
    <div
      v-if="empty"
      v-t="'Recruiting.Dashboard.OpenTasksNoTasks'"
      class="p-3"
    />
    <ul v-else class="list-group list-group-flush">
      <li
        v-for="(item, i) in sortedTasks"
        :key="i"
        class="list-group-item border-0"
      >
        <div class="dashboard-open-task-item" :class="getColor(item.dueState)">
          <a-dashlet-list-item-title>
            <span slot="title" v-text="item.typ" />
            <div
              slot="addition"
              v-t="getText(item.dueState)"
              class="dashboard-open-task-item--due-state-hint"
            />
          </a-dashlet-list-item-title>
          <div class="row">
            <div class="col py-0 text-pf-muted" v-text="item.description" />
          </div>
        </div>
      </li>
    </ul>
    <template slot="actions">
      <a
        v-t="'Recruiting.Dashboard.ShowAll'"
        :disabled="empty"
        :class="{ 'text-pf-muted text-decoration-none': empty }"
        href="javascript:void(0)"
        @click="goToOverview()"
      />
    </template>
  </a-icon-sheet-card>
</template>

<script>
import IconSheetCard from "+/components/card/IconSheetCard";
import DashletListItemTitle from "~/recruiting-system/components/dashboard/DashletListItemTitle";
import _ from "lodash";
import dueStateTypes from "./utils/dueStateTypes.js";

export default {
  components: {
    "a-icon-sheet-card": IconSheetCard,
    "a-dashlet-list-item-title": DashletListItemTitle
  },
  props: {
    data: { type: Object, default: () => {} }
  },
  computed: {
    sortedTasks: function () {
      let sorted = _.sortBy(this.data.openTasks, [
        (item) => this.getOrder(item.dueState),
        "dueDate"
      ]);
      return sorted;
    },
    empty: function () {
      return this.data.count < 1;
    }
  },
  methods: {
    getText(dueState) {
      return dueStateTypes[dueState] ? dueStateTypes[dueState].text : "";
    },
    getColor(dueState) {
      return dueStateTypes[dueState] ? dueStateTypes[dueState].color : "";
    },
    getOrder(dueState) {
      return dueStateTypes[dueState] ? dueStateTypes[dueState].order : 0;
    },
    goToOverview() {
      if (this.empty) {
        return;
      }
      const route = `/main/bm/aufg`;
      this.$router.push(route);
    }
  }
};
</script>
